module.exports = __webpack_public_path__ + "img/460.05fb6034.jpg";